import { useQuery } from '@apollo/client/react';
import { NetworkStatus } from '@apollo/client';
import { ClientPortalResponse } from './types';
import { GET_CLIENT_PORTAL_DATA } from './graphql/clientPortalQueries';

export const useClientPortal = (projectId: string | number) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{ baseProject: ClientPortalResponse }>(
    GET_CLIENT_PORTAL_DATA,
    {
      variables: { id: projectId?.toString() },
      skip: !projectId,
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  );

  return {
    data: data?.baseProject,
    loading,
    isDataReloading: networkStatus !== NetworkStatus.ready,
    error,
    refetch,
  };
};
